import useClickAway from '@patrianna/shared-hooks/useClickAway'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'
import { useRef } from 'react'

import { IS_BRAND_PULSZ } from 'config/brands'
import content from 'prismic-translates/dialog-level-up-modal.json'
import { useAppDispatch } from 'store/hooks'
import { closeSnackbar } from 'store/modules/snackbar/actions'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  bonus: number
  level: number
  vipPoints: number
}

function LevelUpMessage(props: Props) {
  const dispatch = useAppDispatch()
  const ref = useRef<HTMLDivElement | null>(null)

  useClickAway(ref, () => {
    if (IS_BRAND_PULSZ) {
      dispatch(closeSnackbar())
    }
  })

  if (IS_BRAND_PULSZ) {
    return (
      <div ref={ref} className={cx(classes.pulszRoot, 'mt-paper')} data-testid='level-up-message'>
        <h5 className={classes.pulszTitle}>{t('pulsz_points_title')}</h5>

        <p className={cx('mt-typography-body1', classes.pulszSubtitle)}>
          {t('subtitlePart1')} <b>{t('subtitlePart2')}</b>
        </p>

        <div className={classes.pulszList}>
          <div className={classes.pulszListItem}>
            <img className={classes.pulszIcon} src={`${process.env.IMG_ORIGIN}/star-coin-icon.svg`} alt='Gold coin' />
            <div className={classes.pulszRewardContent}>
              <span className={classes.pulszAmount}>{props.bonus}</span>
              <span>{t('gold_coins')}</span>
            </div>
          </div>
          {Boolean(props.vipPoints) && (
            <div className={classes.pulszListItem}>
              <img
                className={classes.pulszIcon}
                src={`${process.env.IMG_ORIGIN}/icons/pulsz-points-icon.svg`}
                alt='Pulsz Points'
              />
              <div className={classes.pulszRewardContent}>
                <span className={classes.pulszAmount}>{props.vipPoints}</span>
                <span>{t('pulsz_points')}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={cx(classes.root, 'mt-paper')}>
      <h5 className={classes.title}>
        {t('title')} {props.level}!
      </h5>

      <p className={cx('mt-typography-body1', classes.description)}>
        <img className={classes.icon} src={`${process.env.IMG_ORIGIN}/coin-icon.svg`} alt='Gold coin' />
        <b>{props.bonus}</b>
        <span className={classes.currencyDescr}>{t('gold_coin')}</span>
      </p>
      {Boolean(props.vipPoints) && (
        <p className={cx('mt-typography-body1', classes.description)}>
          <b>{props.vipPoints}</b>
          <span className={classes.currencyDescr}>{t('vip_points')}</span>
        </p>
      )}
    </div>
  )
}

export default LevelUpMessage
